import { useEffect, useState } from "react";
import axios from "../../utils/axiosInstance";
import "./category.css"; // استایل دلخواه خودت
import CategoryTable from "../../components/list/CategoryTable";
import Modal from "../../components/modal/Modal";
import CategoryForm from "../../components/form/CategoryForm";
const Category = () => {
  const [categories, setCategories] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const fetchData = async () => {
    try {
      setLoading(true);
      // const [productRes, categoryRes] = await Promise.all([
      //   axios.get("/categories?limit=10"),
      // ]);
      const categoryRes = await axios.get("/categories?limit=1000");
      // console.log("category=", categoryRes.data.categories);
      setCategories(categoryRes.data.categories);
    } catch (err) {
      console.error("❌ Error loading data:", err);
      setError("Error Loading data!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleAddClick = () => {
    setEditingCategory(null);
    setModalOpen(true);
  };

  const handleEdit = (category) => {
    setEditingCategory(category);
    setModalOpen(true);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete the category?")) {
      setCategories(categories.filter((cat) => cat.id !== id));
    }
  };

  const handleAfterSubmit = () => {
    fetchData();
    setModalOpen(false);
    alert("✔️ Category saved successfully!");
  };
  if (loading) return <div className="p-3">⏳Loading...</div>;
  if (error) return <div className="p-3 text-danger">{error}</div>;
  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="fw-bold">Modify Category</h4>
        <button
          className="btn btn-sm btn-outline-primary m-2"
          onClick={handleAddClick}
        >
          Add
        </button>
      </div>
      <CategoryTable
        categories={categories}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
      {/* Modal */}
      <Modal show={modalOpen} modalClosed={() => setModalOpen(false)}>
        <CategoryForm
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          category={editingCategory}
          categories={categories}
          onSuccess={handleAfterSubmit}
        />
      </Modal>

    </div>
  );
};

export default Category;
// const handleEdit = (cat) => {
//   /*...*/
// };
// const handleDelete = (id) => {
//   /*...*/
// };
  // const handleSave = (e) => {
  //   e.preventDefault();
  //   const form = e.target;
  //   const name = form.name.value.trim();
  //   const parent = form.parent.value || null;

  //   if (editingCategory) {
  //     // ویرایش
  //     setCategories((prev) =>
  //       prev.map((cat) =>
  //         cat.id === editingCategory.id
  //           ? { ...cat, name, parent: parent ? parseInt(parent) : null }
  //           : cat
  //       )
  //     );
  //   } else {
  //     // افزودن جدید
  //     const newCategory = {
  //       id: Date.now(),
  //       name,
  //       parent: parent ? parseInt(parent) : null,
  //     };
  //     setCategories([...categories, newCategory]);
  //   }

  //   setModalOpen(false);
  //   setEditingCategory(null);
  // };
  // const columns = [
  //   { key: "name", label: "نام دسته" },
  //   {
  //     key: "parent",
  //     label: "دسته والد",
  //     render: (value, row) => {
  //       const parent = categories.find((c) => c.id === value);
  //       return parent ? parent.name : "-";
  //     },
  //   },
  // ];
      {/* <ModalP
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title={editingCategory ? "ویرایش دسته‌بندی" : "افزودن دسته‌بندی"}
      >
        <form onSubmit={handleSave}>
          <div className="mb-3">
            <label className="form-label">نام دسته</label>
            <input
              name="name"
              defaultValue={editingCategory?.name || ""}
              required
              className="form-control"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">دسته والد (اختیاری)</label>
            <select
              name="parent"
              className="form-select"
              defaultValue={editingCategory?.parent || ""}
            >
              <option value="">بدون والد</option>
              {categories
                .filter(
                  (cat) => !editingCategory || cat.id !== editingCategory.id
                )
                .map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
            </select>
          </div>

          <div className="d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-secondary me-2"
              onClick={() => setModalOpen(false)}
            >
              انصراف
            </button>
            <button type="submit" className="btn btn-success">
              ذخیره
            </button>
          </div>
        </form>
      </ModalP> */}
      {/* {modalOpen && (
        <div
          className="custom-modal-backdrop"
          onClick={() => setModalOpen(false)}
        >
          <div
            className="custom-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <h5 className="fw-bold mb-3">
              {editingCategory ? "ویرایش دسته‌بندی" : "افزودن دسته‌بندی"}
            </h5>
            <form onSubmit={handleSave}>
              <div className="mb-3">
                <label className="form-label">نام دسته</label>
                <input
                  name="name"
                  defaultValue={editingCategory?.name || ""}
                  required
                  className="form-control"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">دسته والد (اختیاری)</label>
                <select
                  name="parent"
                  className="form-select"
                  defaultValue={editingCategory?.parent || ""}
                >
                  <option value="">بدون والد</option>
                  {categories
                    .filter(
                      (cat) => !editingCategory || cat.id !== editingCategory.id
                    )
                    .map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-secondary me-2"
                  onClick={() => setModalOpen(false)}
                >
                  انصراف
                </button>
                <button type="submit" className="btn btn-success">
                  ذخیره
                </button>
              </div>
            </form>
          </div>
        </div>
      )} */}